module.exports = __webpack_public_path__ + "img/web_wenz03.1a5e8604.png";